import { render, staticRenderFns } from "./SquareMetersPriceArrayType.vue?vue&type=template&id=415c1fc8&"
import script from "./SquareMetersPriceArrayType.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceArrayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports